import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { Pregnancy } from "./Pregnancy";

class PreviousPregnancies {
    public Remarks: string;
    public MassUnit: WeightUnit;
    public Pregnancies: Pregnancy[];

    constructor(fields?: Partial<PreviousPregnancies>) {
        Object.assign(this, fields);
        this.Pregnancies = fields?.Pregnancies?.map(p => new Pregnancy(p)) ?? [];
        this.MassUnit = fields?.MassUnit ?? WeightUnit.Kilogram;
    }

    public setMassUnit(unit: WeightUnit): void {
        if (this.MassUnit === unit)
            return;

        for (let pregnancy of this.Pregnancies)
            pregnancy.convertMass(this.MassUnit, unit);

        this.MassUnit = unit;
    }
}

export { PreviousPregnancies };
